/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


import ScrollMagic from 'ScrollMagic';
import animationGSAP from 'animation.gsap';
import addIndicators from 'debug.addIndicators';
import TweenMax from 'TweenMax';
import TimelineMax from 'TimelineMax';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      // Grab all elements to be animated and apply the appropriate animation class
      const animationController = new ScrollMagic.Controller( {globalSceneOptions: {triggerHook: 0.90}} );
      const controller = new ScrollMagic.Controller();

      // build scenes
      $( '.js-animate-col, .js-animate-up, .js-animate-down, .js-animate-right' ).each( function() {
        new ScrollMagic.Scene( {triggerElement: this} )
            .setClassToggle( this, 'js-animated' ) // add class toggle
            .addTo( animationController );
      } );

      let sliderCounter = 0;
      let sliderElements = '';

      if ( $( '.testimonials-slider' ).length ) {
        sliderCounter++;
        if ( sliderElements === '' ) {
          sliderElements += '.testimonials-slider';
        } else {
          sliderElements += ', .testimonials-slider';
        }
      }

      if ( $( '.logo-slider' ).length ) {
        sliderCounter++;
        if ( sliderElements === '' ) {
          sliderElements += '.logo-slider';
        } else {
          sliderElements += ', .logo-slider';
        }
      }

      if ( $( '.results-slider' ).length ) {
        sliderCounter++;
        if ( sliderElements === '' ) {
          sliderElements += '.results-slider';
        } else {
          sliderElements += ', .results-slider';
        }
      }


      // let checker = 0;
      // if ( sliderElements ) {
      //   $( sliderElements ).on( 'init', function( event, slick ) {
      //     checker++;
      //     if ( checker === sliderCounter ) { // so stuff doesn't run each time
      //       $( '.block--light' ).each( function( key, val ) {
      //         new ScrollMagic.Scene( {triggerHook: 0, triggerElement: val, duration: $( val ).outerHeight()} )
      //             .setClassToggle( '.navbar', 'nav--alt' ) // add class toggle
      //             .addTo( controller );
      //       } );
      //     }
      //   } );
      // } else {
      //   $( '.block--light' ).each( function( key, val ) {
      //     console.log( 'test' );

      //   } );
      // }

      if ( $( '.main' ).children().first().hasClass( 'block--dark' ) ) {
        new ScrollMagic.Scene( {triggerHook: 0, triggerElement: $( '.main' ).children().first()[0], offset: 20} )
            .setClassToggle( '.desktop-navbar', '.mobile-navbar', 'nav--alt' ) // add class toggle
            // .addIndicators()
            .addTo( controller );
      } else {
        $( '.desktop-navbar' ).addClass( 'nav--alt' );
      }
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'global-animation', COMPONENT );
} )( app );
